import { apiCall } from "@/shared/services/apiCall.js";
import { errorToast, successToast, helper } from "@/shared/services/helper.js";
import dateTime from "@/shared/services/dateTime";
import store from "@/store";

const getUserAccounts = async (payment_methods, reconnectTry = 0) => {
    let responseObj = {
        withdrawAccountType: null,
        userAccounts: [],
        paymentMethods: [],
        metaInfo: null
    }
    try{
        store.dispatch('setGlobalLoader', true);
        let response = await apiCall('get', 'ACCOUNT_DETAILS', null, 'wallet')
        store.dispatch('setGlobalLoader', false);
        if (!response?.data?.success) {
            errorToast(response.data.message);
        }else{
            responseObj.userAccounts = response.data.data.account_list.sort(
                (a, b) => dateTime.convertToTimestamp(b.created_at) - dateTime.convertToTimestamp(a.created_at)
            );
            const { account_list , ...rest} = response?.data?.data;
            responseObj.metaInfo = rest;
            if(Boolean(response?.data?.data?.withdrawal_type == 1)) {
                responseObj.paymentMethods = payment_methods.filter(pm => pm?.method_type == 'bank')
            }
            else if(Boolean(response?.data?.data?.withdrawal_type == 2)) {
                responseObj.paymentMethods = payment_methods.filter(pm => pm?.method_type == 'upi')
            }
             else {
                responseObj.paymentMethods = payment_methods.filter(pm => pm?.method_type != 'payment_gateway' && pm?.method_type != 'social');
            }

        } 
        return responseObj;
    }catch(error){
        store.dispatch('setGlobalLoader', false);
        if(reconnectTry < 3 && !error) {
            getUserAccounts(reconnectTry + 1);
        }
        else {
            if (error) {
                errorToast(error[0]);
            }
        }
    }
};

const removeAccount = async (id) => {
    try{
        let response = await apiCall('delete', 'DELETE_ACCOUNT',{}, 'wallet', {accountId: id})
        if (!response?.data?.success) {
            errorToast(response.data.message);
            return false
        }else{
            successToast(response?.data?.message);
            return true
        } 
    }catch(error){
        errorToast(error[0]);
        return false
    }
};

const withDrawWalletPayloadEncryption = async (amount, client_account_id , transaction_password)=>{
 try {        
        let data = {
            amount,
            client_account_id,
            ...transaction_password
        }

        let response = await apiCall('post', 'WITHDRAW_PAYLOAD_ENCRYPT_REQUEST', data, 'wallet');
        if (response.data.error) {
            errorToast(response.data.error);
            return { error : response.data.error}
        }else{
            successToast(response?.data?.message)
            return { token: response?.data?.data };
        } 
    } catch (error) {
        if (error) {
            errorToast(error);
            return { error : error }
        }
    }
};

const withdrawWalletAmount = async (withdrawAmount, accountId , otp = null) => {
        let user = store.getters.stateUser;
        const is2faEnabled = user?.is_twofa_enable ?? false ;
        const transaction_password = (is2faEnabled && otp  && { 'transaction_password' : otp });
    try {
        store.dispatch('setGlobalLoader', true);
        let { token , error } = await withDrawWalletPayloadEncryption(parseFloat(withdrawAmount), accountId , transaction_password);
        if(token){
        let data = {
            "amount": withdrawAmount,
            "client_account_index": accountId,
            "payload_token": token,
            // "client_created_date": dateTime.sportItemDate(accountDetails.created_at, 'YYYY-MM-DD HH:mm:ss'),
            "type": "client_withdrawal"
        }

        let response = await apiCall('post', 'GET_ID_WALLET_WITHDRAW', data);
        store.dispatch('setGlobalLoader', false);
        if (response.data.error) {
            errorToast(response.data.error);
            return { error : response.data.error}
        }else{
            successToast(response?.data?.message)
            return true
        }
    } 
    else {
        store.dispatch('setGlobalLoader', false);
        return { error : error };
    } 
    } catch (error) {
        store.dispatch('setGlobalLoader', false);
        if (error) {
            errorToast(error);
            return { error : error }
        }
    }
}
export {
    getUserAccounts,
    removeAccount,
    withdrawWalletAmount
}